export const V1_SET_SEARCH = 'V1_SET_SEARCH'

export default data => {
  return {
    type: V1_SET_SEARCH,
    data,
  }
}
